import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SiteState {
  sites: { id: string; name: string }[];
  selectedSites: string[];
}

const initialState: SiteState = {
  sites: [
    { id: '1', name: 'ng office' },
    { id: '2', name: 'Another Site' },
  ],
  selectedSites: [],
};

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    toggleSiteSelection: (state, action: PayloadAction<string>) => {
      if (action.payload === 'all') {
        state.selectedSites =
          state.selectedSites.length === state.sites.length ? [] : state.sites.map((site) => site.id);
      } else {
        if (state.selectedSites.includes(action.payload)) {
          state.selectedSites = state.selectedSites.filter((id) => id !== action.payload);
        } else {
          state.selectedSites.push(action.payload);
        }
      }
    },
    clearSiteSelection: (state) => {
      state.selectedSites = [];
    },
  },
});

export const { toggleSiteSelection, clearSiteSelection } = siteSlice.actions;
export default siteSlice.reducer;
